import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDate } from "@/lib/constants";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/logs");
        setLogs(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl font-bold">Journal d'actions</h1>
      <p className="text-gray-600 mt-1">Historique complet des actions administrateur.</p>

      <div className="sl-card mt-6 p-0 overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-gray-500">Chargement…</div>
        ) : logs.length === 0 ? (
          <div className="p-10 text-center text-gray-500">Aucune action enregistrée.</div>
        ) : (
          <table className="w-full text-sm" data-testid="logs-table">
            <thead className="bg-[var(--sl-bg-alt)] text-xs uppercase text-gray-500">
              <tr>
                <th className="text-left p-4">Quand</th>
                <th className="text-left p-4">Admin</th>
                <th className="text-left p-4">Action</th>
                <th className="text-left p-4">Cible</th>
                <th className="text-left p-4">Détails</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-t border-gray-100">
                  <td className="p-4 text-gray-500 whitespace-nowrap">{formatDate(l.created_at)}</td>
                  <td className="p-4">{l.admin_email}</td>
                  <td className="p-4 font-mono text-xs">{l.action}</td>
                  <td className="p-4 font-mono text-xs">{l.target}</td>
                  <td className="p-4 font-mono text-xs text-gray-500 break-all max-w-md">
                    {Object.keys(l.details || {}).length ? JSON.stringify(l.details) : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
